<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <div class="space-y-6" data-testid="payout-explanation">
    <div>
      <h3 class="text-base font-semibold text-white">{{ t('organizer.organisation.payments.why_title') }}</h3>
      <p class="mt-2 text-sm leading-relaxed text-slate-300">{{ t('organizer.organisation.payments.why_body') }}</p>
      <p class="mt-2 text-sm leading-relaxed text-slate-400">{{ t('organizer.organisation.payments.free_note') }}</p>
    </div>

    <div>
      <h3 class="text-base font-semibold text-white">{{ t('organizer.organisation.payments.needs_title') }}</h3>
      <ul class="mt-2 list-disc space-y-1.5 pl-5 text-sm leading-relaxed text-slate-300">
        <li>{{ t('organizer.organisation.payments.needs_business') }}</li>
        <li>{{ t('organizer.organisation.payments.needs_representative') }}</li>
        <li>{{ t('organizer.organisation.payments.needs_bank') }}</li>
      </ul>
    </div>

    <div>
      <h3 class="text-base font-semibold text-white">{{ t('organizer.organisation.payments.steps_title') }}</h3>
      <ol class="mt-2 list-decimal space-y-1.5 pl-5 text-sm leading-relaxed text-slate-300">
        <li>{{ t('organizer.organisation.payments.step_1') }}</li>
        <li>{{ t('organizer.organisation.payments.step_2') }}</li>
        <li>{{ t('organizer.organisation.payments.step_3') }}</li>
        <li>{{ t('organizer.organisation.payments.step_4') }}</li>
      </ol>
    </div>

    <p class="rounded-xl border border-slate-600 bg-slate-700/30 px-4 py-3 text-sm leading-relaxed text-slate-300">
      {{ t('organizer.organisation.payments.privacy_note') }}
    </p>
  </div>
</template>
